import * as React from 'react';
import useHabitat from '../../hooks/useHabitat';
import HubsModuleProps from './type';
import { Discipline } from '../../core/typings';
import CompetitionHeader from '../../components/CompetitionHeader';
import Countdown from '../../components/Countdown';
import CountdownModule from '../../components/CountdownModule';
import EventHeader from '../../components/EventHeader';
import RaceHeader from '../../components/RaceHeader';
import Sponsors from '../../components/Sponsors';
import Tabs, { Tab, TabPanel } from '../../components/common/Tabs';
import Calendar from '../../components/Calendar';
import './styles.scss';

const HubsModule = ({
  raceHubHeader,
  competitionHubHeader,
  eventHubHeader,
  tabs,
  sponsors,
}: HubsModuleProps) => {
  useHabitat();

  return (
    <div className="race-hub-module page-template">
      {raceHubHeader && (
        <RaceHeader {...raceHubHeader} />
      )}

      {competitionHubHeader && competitionHubHeader.tissotCountdown && (
        <Countdown
          timestamp={competitionHubHeader.tissotCountdown.date ?? ''}
          tissotCountdownLogo={competitionHubHeader.tissotCountdown.logo}
        />
      )}

      {competitionHubHeader && (
        <CompetitionHeader {...competitionHubHeader} />
      )}

      {(eventHubHeader?.headerModule && !eventHubHeader?.liveEventHeaderModule) && (
        <CountdownModule {...eventHubHeader.headerModule} />
      )}

      {eventHubHeader?.liveEventHeaderModule && (
        <EventHeader {...eventHubHeader.liveEventHeaderModule} />
      )}

      {tabs && tabs.tabs.length === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: tabs.tabs[0].content as string,
          }}
        />
      )}

      {tabs && tabs.tabs.length > 1 && (
        <div className="race-hub-module__tabs">
          <Tabs
            discipline={tabs.discipline as Discipline}
            withScrollPaddles
            isEvent={!!eventHubHeader}
          >
            {tabs.tabs.map((tab) => (
              <Tab key={tab.slug} id={tab.slug} label={tab.label} date={tab.date} />
            ))}
            {tabs.tabs.map((tab) => (
              <TabPanel key={`panel-${tab.slug}`} tabId={tab.slug}>
                {(tab.content && !tab.isResult) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: tab.content,
                    }}
                  />
                )}
                {(tab.isResult && tab.bearerToken && tab.filters) && (
                  <Calendar
                    filters={tab.filters}
                    disciplineCode=""
                    bearerToken={tab.bearerToken}
                    isCwcResult
                  />
                )}
                {tab.subTabs && (
                  <Tabs discipline={tabs.discipline as Discipline} nested>
                    {tab.subTabs.map((subTab) => (
                      <Tab key={subTab.slug} id={subTab.slug} label={subTab.label} />
                    ))}
                    {tab.subTabs.map((subTab) => (
                      <TabPanel key={`panel-${subTab.slug}`} tabId={subTab.slug}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: subTab.content as string,
                          }}
                        />
                      </TabPanel>
                    ))}
                  </Tabs>
                )}
              </TabPanel>
            ))}
          </Tabs>
        </div>
      )}

      {sponsors && (
        <Sponsors sponsors={sponsors.sponsors} title={sponsors.title} />
      )}
    </div>
  );
};

export default HubsModule;
